import { html, LitElement } from 'lit';
import styles from './arc-spinner.styles.js';
export default class ArcSpinner extends LitElement {
    render() {
        return html `
      <svg id="main" aria-busy="true" aria-live="polite">
        <circle id="track" cx="0.5em" cy="0.5em" r="0" />
        <circle id="indicator" cx="0.5em" cy="0.5em" r="0" />
      </svg>
    `;
    }
}
ArcSpinner.tag = 'arc-spinner';
ArcSpinner.styles = styles;
